/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

const jsonData = {
  "squareup": {
    "nested": {
      "regulator": {
        "nested": {
          "action": {
            "nested": {
              "v1": {
                "nested": {
                  "Entity": {
                    "fields": {
                      "type": {
                        "type": ".squareup.regulator.action.v1.Entity.Type",
                        "id": 1,
                        "rule": "optional"
                      },
                      "token": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "Type": {
                        "values": {
                          "TYPE_UNSPECIFIED": 0,
                          "TYPE_REGISTER_UNIT": 1,
                          "TYPE_REGISTER_MERCHANT": 2,
                          "TYPE_REGISTER_PAYMENT": 3,
                          "TYPE_CASH_CUSTOMER": 4,
                          "TYPE_CASE": 5,
                          "TYPE_CAPITAL_BUSINESS_APPLICATION": 6,
                          "TYPE_CAPITAL_CUSTOMER": 7,
                          "TYPE_CAPITAL_PLAN": 8,
                          "TYPE_INSTRUMENT_TOKEN": 9,
                          "TYPE_CAPITAL_LEGAL_ENTITY": 10,
                          "TYPE_CREDIT_CARD_DISPUTE": 11,
                          "TYPE_DEBIT_CARD_DISPUTE": 12
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.regulator?.nested?.action?.nested?.v1?.nested?.Entity && !$root.nested?.squareup?.nested?.regulator?.nested?.action?.nested?.v1?.nested?.Entity?.nested?.Type) {
	$root.addJSON(jsonData);
}

/**
 * SOURCE Entity @ squareup/regulator/action/v1/entity.proto at 9:1
 */
export const Entity = $root.lookupType('squareup.regulator.action.v1.Entity');
fixType(Entity, {
  type: { required: true },
  token: { required: true },
});
Builder.createAndAttachToType(Entity);
/**
 * SOURCE Type @ squareup/regulator/action/v1/entity.proto at 13:3
 */
Entity.Type = $root.lookupEnum('squareup.regulator.action.v1.Entity.Type').values;
